import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { CslCheckinResponse } from '~client/model/csl-checkin-response';
import { CslInitializeResponse } from '~client/model/csl-initialize-response';

export class CslUserController extends BaseController {
  /* Check-in and see if the user can still view the stream on this device. */
  public checkIn$(inventoryItemId: number): Observable<CslCheckinResponse> {
    return this.post$(`/streaming/csl/user/checkIn?inventoryItemId=${inventoryItemId}`);
  }
  /* Initialize a CSL session for this user's device. Revoke's stream access to the oldest device that's still watching the stream. */
  public initialize$(inventoryItemId: number): Observable<CslInitializeResponse> {
    return this.post$(`/streaming/csl/user/initialize?inventoryItemId=${inventoryItemId}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/csl-user-controller.ts